import React, { useRef, useEffect } from 'react';
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import AppLink from '../AppLink';
import BrowserLink from '../BrowserLink';
import './FeaturedSlider.scss';

SwiperCore.use([Autoplay, Pagination, Navigation]);

const sliderSettings = {
  navigation: true,
  pagination: {
    clickable: true
  },
  loop: true,
  loopAdditionalSlides: 1,
  autoplay: {
    delay: 10000,
  },
  speed: 100,
  breakpoints: {
    1024: {
      spaceBetween: 20
    }
  },
};

export function FeaturedSlider({ slides }) {
  const slider = useRef();

  useEffect(() => {
    const sliderEl = slider.current;
    const arrowLeftEl = sliderEl?.querySelector('.swiper-button-prev');
    const arrowRightEl = sliderEl?.querySelector('.swiper-button-next');

    arrowLeftEl?.addEventListener('click', sendPrevBtnClickToAnalytics);
    arrowRightEl?.addEventListener('click', sendNextBtnClickToAnalytics);

    return () => {
      arrowLeftEl?.removeEventListener('click', sendPrevBtnClickToAnalytics);
      arrowRightEl?.removeEventListener('click', sendNextBtnClickToAnalytics);
    };
  }, []);

  const sendPrevBtnClickToAnalytics = () => {
    // actid=9
    window.analytics?.track("button:click", {
      "button_name": "swiper-button-prev",
      "parent_object_title": "Featured slider",
      "url": window.location.href
    });
  }
  const sendNextBtnClickToAnalytics = () => {
    // actid=9
    window.analytics?.track("button:click", {
      "button_name": "swiper-button-next",
      "parent_object_title": "Featured slider",
      "url": window.location.href
    });
  }

  if(!slides?.length) {
    return null;
  }

  const filteredSlides = slides.filter((slide) => slide.react_route || slide.url);

  return (
    <div className="FeaturedSlider">
      <Swiper ref={slider} {...sliderSettings}>
        {filteredSlides.map((slide, i) => (
          <SwiperSlide key={i}>
            <Slide slide={slide} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

function Slide({ slide }) {
  const wrapperClasses = 'FeaturedSlider__slide';

  const content = (
    <img
      className="FeaturedSlider__slide-img"
      src={slide.image}
      alt=""
      onClick={(e) => {
        // actid=2.1
        window.analytics?.track("banner:click", {
          "title": slide.image,
          "url": slide.react_route ? slide.react_route : slide.url
        });
      }}
    />
  );

  if(slide.react_route) {
    return (
      <AppLink to={slide.react_route} className={wrapperClasses}>
        {content}
      </AppLink>
    );
  }

  if(slide.url) {
    return (
      <BrowserLink href={slide.url} className={wrapperClasses}>
        {content}
      </BrowserLink>
    );
  }

  return null;
}
